import { InPageEditableSectionField } from "./types";

export const SectionTemplateBrField = (key: string, hidden = false): InPageEditableSectionField => ({
  key,
  label: "",
  hidden,
  render: () => null,
});